/**
 * WordPress exports
 */

export { Content } from './shortcodes/Content';

export { WordpressApiClient } from './WordpressApiClient';
export { fetchPost } from './api/queries/fetchPost';
export { default as transformImage } from './api/transform/transformImage';
export type { ImageOptions } from './api/transform/transformImage';
export { default as fetchDefaultContributor } from './api/queries/fetchDefaultContributor';
export { withDefaultContributors } from './api/lib/withDefaultContributors';
export {
  generateSchema,
  isOrganizationPage,
  ORGANIZATION_PAGE_URIS,
} from './api/generateSchema';

export {
  withShortCode,
  convertKeysToCamelCase,
  convertKeysToSnakeCase,
} from './shortcodes/utils';

/**
 * Types
 */

export type {
  ShortCodeRegistry,
  ShortCode,
  ContentProps,
  EnrichmentContext,
} from './shortcodes/types';

export type {
  CamelToSnakeCase,
  SnakeToCamelCase,
  ToCamelCase,
  ToSnakeCase,
} from './shortcodes/utils';

export type { PostNode } from './api/queries/fetchPost';
export type { NavigationCta } from './api/queries/fetchMenus';
export type { TransformedSeo } from './api/transform/transformSEO';
export type {
  SchemaGeneratorData,
  ContributorProfileSchemaData,
  CategoryHubSchemaData,
} from './api/generateSchema';
export type {
  ConfigProps,
  MenuItem,
  MenuLocations,
  MenuLocationType,
  SchemaType,
} from './configTypes';

export { fetchSitemapFromApi } from './api/queries/fetchSitemapFromApi';
export type { FetchSitemapFromApiParams } from './api/queries/fetchSitemapFromApi';

export { fetchPostsByCategory } from './api/queries/fetchPostsByCategory';
export { fetchPrivatePost } from './api/queries/fetchPrivatePost';
export { default as fetchContributorsByCategory } from './api/queries/fetchContributorsByCategory';
export type { ContributorCard as LibContributorCard } from './api/queries/fetchContributorsByCategory';
export {
  default as fetchContributorProfile,
  contributorProfileQuery,
} from './api/queries/fetchContributorProfile';
export type {
  ContributorProfileData,
  ContributorProfileData as LibContributorProfileData,
  ContributorPost,
  ContributorPost as LibContributorPost,
  ContributorSocialMedia,
  ContributorHighlightField,
} from './api/types/contributorProfile';
export {
  partitionContributorSocialMedia,
  CONTRIBUTOR_SOCIAL_META_KEYS,
} from './api/lib/partitionContributorSocialMedia';
export {
  normalizeContributorsBasePath,
  getContributorPath,
  getContributorPathSegment,
} from './api/lib/contributorPaths';
export { formatHighlightFieldTitle } from './api/lib/formatHighlightFieldTitle';
export {
  resolveHighlightSnippet,
  type ContributorHighlightSnippet,
} from './api/lib/transformContributorNode';

export { default as fetchEmbeddedPosts } from './api/queries/fetchEmbeddedPosts';
export { default as fetchEmbeddedPostsByCat } from './api/queries/fetchEmbeddedPostsByCat';

export { default as fetchGravityForms } from './api/queries/fetchGravityForms';
export type { GravityFormResponse } from './api/queries/fetchGravityForms';

export type {
  GroupedSitemapResponse,
  SitemapArticleObject,
  SitemapApiResponse,
  SitemapApiItem,
  SitemapCMSEnvironment,
  PostsByCategoryResult,
  TransformedCategory,
  TransformedItemPost,
  TransformedItemContributor,
  PrivatePostNode,
} from './api/types';
export { SitemapEnvironment } from './api/types';
